import { emailRegexValidation, phoneRegexValidation } from '../../utils/validate';
import { loginType } from './constants';

const validate = (values, props) => {
  const errors = {};

  if (values.loginType === loginType.LOGIN_VIA_PASSWORD
    && !(emailRegexValidation(values.email) || phoneRegexValidation(values.email))) {
    errors.email = 'required';
  }
  if (values.loginType === loginType.LOGIN_VIA_SMS && !values.phone) {
    errors.phone = 'required';
  }
  if (!values.password) {
    errors.password = 'required';
  }

  return errors;
};

export default validate;
